/**
 * @returns {Element | null} the tippy container
 */
export default function getTippyEl() {
	return document.querySelector('#tippy-container') || document.body
}
